module.exports = __webpack_public_path__ + "media/img/mr-ui-6b090b09.jpg";